import { useMemo } from 'react'
import {
  useHasReceptor,
  useReceptor,
} from 'src/pages/Receptors/receptors.hooks'
import {
  SharepointOptionsHelperResponse,
  SharepointReceptorHelperResponse,
  SharePointOptions,
} from './SharepointFilePickerModal.types'

export const useSharepointReceptorHelper =
  (): SharepointReceptorHelperResponse => {
    const sharepointReceptorModelId = 'trr-sharepoint'
    const { data: hasReceptorData } = useHasReceptor(
      sharepointReceptorModelId,
      true,
    )
    const hasReceptor = useMemo(
      () => hasReceptorData?.getHasReceptor() || false,
      [hasReceptorData],
    )
    const { data: receptor } = useReceptor({
      modelId: sharepointReceptorModelId,
      shouldFetch: hasReceptor,
    })

    return { hasSharepointReceptor: hasReceptor, receptor }
  }

export const useSharepointOptionsHelper = (
  documentLibrary?: string,
): SharepointOptionsHelperResponse => {
  const options: SharePointOptions = useMemo(
    () => ({
      sdk: '8.0',
      entry: {
        sharePoint: {
          byPath: {
            fallbackToRoot: !documentLibrary,
            ...(documentLibrary ? { list: documentLibrary } : {}),
          },
        },
      },
      authentication: {},
      messaging: { origin: window.location.origin, channelId: '27' },
      typesAndSources: { mode: 'files', pivots: { oneDrive: false } },
      selection: { mode: 'multiple' },
      search: { enabled: true },
    }),
    [documentLibrary],
  )

  const optionsQueryString = useMemo(
    () => new URLSearchParams({ filePicker: JSON.stringify(options) }),
    [options],
  )

  return { options, optionsQueryString }
}
